import PropTypes from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import { trackEvent } from 'dibs-tracking';
import Dropdown, { sizeConstants } from '../Dropdown/Dropdown';
import { FullWidthDropdown } from '../Dropdown/FullWidthDropdown';
import SiteNavDropdownContent from './SiteNavDropdownContent';
import classnames from 'classnames';
import styles from './SiteNav-style.scss';

export class SiteNavItemComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = { isVisible: false };
        this.onHide = this.onHide.bind(this);
        this.onShow = this.onShow.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick() {
        const { name } = this.props;

        trackEvent({
            action: 'header navigation click',
            category: 'navigation',
            label: `${name.toLowerCase()} header link|${name.toLowerCase()}`,
        });
    }
    onHide() {
        this.setState({ isVisible: false });
    }
    onShow() {
        this.setState({ isVisible: true });
    }
    render() {
        const {
            name,
            url,
            isHighlighted,
            isUserTypeTrade,
            items,
            showFullWidthNav,
            navigationModule,
        } = this.props;
        const { isVisible } = this.state;
        const itemClasses = classnames(styles.item, { [styles.fullWidth]: showFullWidthNav });
        const itemLinkClasses = classnames(styles.itemLink, { [styles.highlight]: isHighlighted });

        const DropdownComponent = showFullWidthNav ? FullWidthDropdown : Dropdown;
        let dropdownProps;
        if (showFullWidthNav) {
            dropdownProps = {
                onShow: this.onShow,
                onHide: this.onHide,
                wrapperClass: styles.fullWrapper,
            };
        } else {
            dropdownProps = { size: sizeConstants.SIZE_EXTRA_LARGE };
        }

        return (
            <div className={itemClasses}>
                <DropdownComponent {...dropdownProps}>
                    <a
                        className={itemLinkClasses}
                        href={url}
                        data-tn={`global-nav-item-link-${name
                            .toLowerCase()
                            .replace(/[^a-zA-Z0-9]+/gi, '-')}`}
                        onClick={this.handleClick}
                    >
                        {name}
                        {showFullWidthNav &&
                            isVisible && (
                                <div
                                    className={
                                        isUserTypeTrade
                                            ? styles.linkUnderlineTrade
                                            : styles.linkUnderline
                                    }
                                />
                            )}
                    </a>
                    {items && items.length ? (
                        <SiteNavDropdownContent
                            showFullWidthNav={showFullWidthNav}
                            items={items}
                            trackingLabelPrefix={name}
                            navigationModule={navigationModule}
                        />
                    ) : null}
                </DropdownComponent>
            </div>
        );
    }
}

SiteNavItemComponent.propTypes = {
    name: PropTypes.string,
    url: PropTypes.string,
    isUserTypeTrade: PropTypes.bool,
    items: PropTypes.array,
    showFullWidthNav: PropTypes.bool,
    isHighlighted: PropTypes.bool,
    navigationModule: PropTypes.object,
};

const mapStateToProps = ({ header }) => {
    const { isUserTypeTrade } = header;
    return {
        isUserTypeTrade,
    };
};

export default createFragmentContainer(connect(mapStateToProps)(SiteNavItemComponent), {
    navigationModule: graphql`
        fragment SiteNavItem_navigationModule on NavigationModule {
            ...SiteNavDropdownContent_navigationModule
        }
    `,
});
